import React from "react";
import { Fade } from "react-awesome-reveal";
import { useMediaQuery } from "react-responsive";
import "../styles/PorqueElegirnos.scss";
import id1 from "../images/identificadores/1.svg";
import id2 from "../images/identificadores/2.svg";
import id3 from "../images/identificadores/3.svg";
import id4 from "../images/identificadores/4.svg";
import id5 from "../images/identificadores/5.svg";

const PorqueElegirnos = () => {
  const isMobile = useMediaQuery({ query: "(max-width: 480px)" });
  let velFade = 2000;

  const tarjetas = [
    {
        id: 1,
        imagen: id1,
        titulo: 'Experiencia y Maestría',
        texto: 'Con años de experiencia y maestría en limpieza industrial y comercial, ofrecemos soluciones personalizadas y de alta calidad para satisfacer todas las necesidades de nuestros clientes.',
    },
    {
        id: 2,
        imagen: id2,
        titulo: 'Calidad Garantizada',
        texto: 'Ofrecemos limpieza de la más alta calidad, garantizando resultados impecables y un servicio confiable que cumple con las expectativas de cada cliente, en todo momento.',
    },
    {
        id: 3,
        imagen: id3,
        titulo: 'Precios Accesibles',
        texto: 'Brindamos servicios de limpieza de alta calidad a precios accesibles, adaptados a las necesidades de cada cliente, sin comprometer la excelencia en el trabajo realizado.',
    },
    {
        id: 4,
        imagen: id4,
        titulo: 'Servicio Integral',
        texto: 'Ofrecemos un servicio integral de limpieza que cubre todas las áreas necesarias, asegurando soluciones completas y personalizadas para empresas, oficinas y hogares.',
    },
    {
        id: 5,
        imagen: id5,
        titulo: 'Comprometidos con tu Éxito',
        texto: 'Estamos comprometidos con el éxito de nuestros clientes, brindando servicios de limpieza de alta calidad que superan expectativas y contribuyen al bienestar y productividad de cada espacio.',
    },
  ];

  return (
    <section className="text-center" id="porqueE">
      <center>
        <Fade>
          <br/><h4 className="fw-bold fs-3 titlePorqueE">
            ¿POR QUÉ ELEGIRNOS?
          </h4>
        </Fade>
      </center>
      <div className="containerCards">
            {tarjetas.map((tarjeta) => (
                <div key={tarjeta.id} className="containerCard text-center">
                    {isMobile && (
                        <Fade duration={velFade}>
                            <img className="imgCard" src={tarjeta.imagen} alt={tarjeta.titulo} />
                            <div className="containerCardText">
                                <p className="firstText fw-bold">{tarjeta.titulo}</p>
                                <p className="textIdentificador">{tarjeta.texto}</p>
                            </div>
                        </Fade>
                    )}
                    {!isMobile && (
                        <div>
                            <img className="imgCard" src={tarjeta.imagen} alt={tarjeta.titulo} />
                            <div className="containerCardText">
                                <p className="firstText fw-bold">{tarjeta.titulo}</p>
                                <p className="textIdentificador">{tarjeta.texto}</p>
                            </div>
                        </div>
                    )}
                </div>
            ))}
      </div>
      <br/><br/><br/>
    </section>
  );
};

export default PorqueElegirnos;
